import { createContext, useContext } from 'react';

// The signed-in viewer's context: the /api/me payload (workspace, agent | endUser,
// capabilities, …) + refresh() (re-read /api/me) + navigate(to, { replace }) + location.
// App.jsx provides it for the SPA; the KB pages' header island (client/astro/src/islands/
// HeaderIsland.jsx — Settings / Notifications opened in place over a KB page) provides the
// same shape. In its own tiny module so every consumer (the Settings sections, the header
// menus, the notifications panel) imports it without pulling App.jsx — and with it the whole
// portal (socket, boot cache, page routes) — into the KB island's bundle.
export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);
